import styled from '@emotion/styled';
import { ob } from '../../onboardingV2.tokens';

const palette = {
    tip: {
        bg: ob.color.lime50,
        border: ob.color.limeBorder,
        tile: ob.color.lime200,
        fg: ob.color.brand,
    },
    info: {
        bg: ob.color.lime50,
        border: ob.color.limeBorder,
        tile: ob.color.lime200,
        fg: ob.color.brand,
    },
    warning: {
        bg: ob.color.warningBg,
        border: ob.color.warningBorder,
        tile: ob.color.demoBg,
        fg: ob.color.warningText,
    },
    error: {
        bg: ob.color.errorBg,
        border: ob.color.errorBorder,
        tile: '#FDE2E2',
        fg: ob.color.error,
    },
};

export const Box = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border: 1px solid ${({ variant }) => palette[variant].border};
    border-radius: ${ob.radius.lg};
    background: ${({ variant }) => palette[variant].bg};
    text-align: left;

    &:focus {
        outline: none;
    }

    &:focus-visible {
        box-shadow: ${ob.focusRing};
    }
`;

export const IconTile = styled.span`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 10px;
    background: ${({ variant }) => palette[variant].tile};
    color: ${({ variant }) => palette[variant].fg};

    i {
        font-size: 18px;
        line-height: 1;
    }
`;

export const Text = styled.div`
    min-width: 0;
    padding-top: 5px;
    font-size: 14px;
    line-height: 1.45;
    color: ${ob.color.body};

    strong {
        display: block;
        margin-bottom: 2px;
        font-size: 15px;
        font-weight: 700;
        color: ${({ variant }) => palette[variant].fg};
    }

    a {
        color: ${({ variant }) => palette[variant].fg};
        font-weight: 700;
        text-decoration: underline;
        text-underline-offset: 2px;
    }

    p {
        margin: 0;
    }

    p + p,
    p + div {
        margin-top: 8px;
    }
`;
